import React from "react";

const Social = () => {
    return (
        <div className="home__social">
            <a href="https://www.instagram.com/jacobgijjah/" className="home__social-icon" target="_blank">
                <i className="uil uil-instagram"></i>
            </a>
            <a href="https://twitter.com/gijjah_jacob" className="home__social-icon" target="_blank">
                <i className="uil uil-twitter"></i>
            </a>
            <a href="https://github.com/Jacobgijah" className="home__social-icon" target="_blank">
                <i className="uil uil-github-alt"></i>
            </a>
        </div>
    )
}

export default Social